import React, { useState } from 'react';
import './App.css';
import { ChartsArea } from './ChartsArea';
import { ChoiceList } from './widgets/ChoiceList';
import { CustomRulesArea } from './customRules/CustomRulesArea';
import { PhonotacticsArea } from './phonotactics/PhonotacticsArea';
import { RunRulesArea } from './RunRulesArea';
import { MakerArea } from './maker/MakerArea';
import { ExamineArea } from './examine/ExamineArea';
import { PieArea } from './pie/PieArea';
import { WestUSEssay } from './ga-essay/GaEssay';
import { SpeechEssay } from './speechEssay/SpeechEssay';
import { PrimeArea } from './prime/PrimeArea';
import { PronounceEssay } from './pronounceEssay/PronounceEssay';
import { speakPhonemes } from '../speak/speakPhonemes';
import { ChartEssay } from './chartEssay/ChartEssay';
import { AccentEssay } from './accentEssay/AccentEssay';
import { RulesEssay } from './rulesEssay/RulesEssay';
import { Lushootseed } from './lushootseed/Lushootseed';
import { Testing } from './testing/Testing';
import { DialogEssay } from './dialogEssay/DialogEssay';
import { OrthographyArea } from './ortho/OrthographyArea';
import { MandarinArea } from './mandarin/MandarinArea';

const version = '2.1';

const pages = ['default-rules', 'custom-rules', 'pie', 'all-charts', 'phonotactics', 'maker', 'examine', 'testing',
  'prime', 'accent-essay', 'westus-essay', 'speech-essay', 'pronounce-essay', 'chart-essay', 'rules-essay', 'dialog-essay',
  'orthography', 'lushootseed', 'mandarin'];

function App() {
  const [which, setWhich] = useState(getStartingPage());

  function clickTitle() {
    speakPhonemes("ˈfoʊ̯nim ˌʃɪftɝ");
  }

  // if ?list=anything, add the page nav list to the top
  const params = new URLSearchParams(document.location.search);
  const navList = params.get('list') === null ? <></>
    : <ChoiceList items={pages} selectedItem={which} onSelect={setWhich} />;

  // essays link back to prime
  const switchPageOptions = which === 'prime' ? <></>
    : which.includes('-essay') || which === 'orthography' ? <a href='?page=prime' className='link-to-main'>main page</a>
      : <></>;

  const mainArea = getArea(which);
  const footer = getFooter();
  return (
    <div className="App">
      <header className="App-header">
        <div style={{ display: 'grid', gridTemplateColumns: '600px auto auto' }}>
          <div className='title' onClick={clickTitle}>/ˈfoʊ̯nim ˌʃɪftɝ/</div>
          <div>{navList}</div>
          <div>{switchPageOptions}</div>
        </div>
      </header>
      <br />
      {mainArea}
      {footer}
    </div>
  );
}

function getArea(which: string) {
  switch (which) {
    case 'default-rules': return <RunRulesArea original={'text gets converted phonetically and then rules are applied'} />;
    case 'custom-rules': return <CustomRulesArea />;
    case 'pie': return <PieArea />;
    case 'all-charts': return <ChartsArea />;
    case 'phonotactics': return <PhonotacticsArea />;
    case 'maker': return <MakerArea />;
    case 'examine': return <ExamineArea />;
    case 'testing': return <Testing />;
    case 'prime': return <PrimeArea />;
    case 'accent-essay': return <AccentEssay />;
    case 'westus-essay': return <WestUSEssay />;
    case 'speech-essay': return <SpeechEssay />;
    case 'pronounce-essay': return <PronounceEssay />;
    case 'chart-essay': return <ChartEssay />;
    case 'rules-essay': return <RulesEssay />;
    case 'dialog-essay': return <DialogEssay />;
    case 'orthography': return <OrthographyArea />;
    case 'lushootseed': return <Lushootseed />;
    case 'mandarin': return <MandarinArea />;
  }
  return <PrimeArea />;
}

/** if the URL contains ?page=<page> that's valid, use it */
function getStartingPage(): string {
  const params = new URLSearchParams(document.location.search);
  const page = params.get('page');
  if (page !== null && pages.includes(page)) {
    return page;
  }
  return 'prime';
}

function getFooter() {
  return (<>
    <br />
    <hr />
    <p>
      v{version}
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      Copyright © Scott Sherman 2025-26
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      send comments to <i>comments</i> at this domain
    </p>
  </>)
}

export default App;
